import React from 'react';
import './WelcomeModal.scss';
import {Modal} from "antd";
import {CloseIcon, WelcomeLogo} from "../../image";
import {Text} from "../index";
import {Button} from "../Button";
import {useTranslation} from "react-i18next";
import {UpdateOpenStepsList} from "../../redux/actions/tourActions";
import {useDispatch, useSelector} from "react-redux";
import {KEY_LOCAL_STORAGE_DONT_VISIBLE_WELCOME_MODAL} from "../Tour/helpers";
import {ApiStatus} from "../../utils/constants";
import {Loader} from "../../shared/features/Loader";
import {useTourActions} from "../Tour/hooks";

const WelcomeModal = ({open, onClose}) => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const googleToken = useSelector(state => state.userCalendars?.googleToken);
    const outlookToken = useSelector(state => state.userCalendars.outlookInfo?.token?.access_token);
    const channels = useSelector(state => state.channels?.channels || []);
    const isConnectedCalendar = Boolean(googleToken) || Boolean(outlookToken);
    const {handleClickNextStep1List, handleClickNextStep2List, handleClickNextStep4List} = useTourActions();
    const isNextStepThree = channels.some((item) => item.videos_count > 0);
    const isFetchingVideos = useSelector(state => state.videos.isFetchingVideos);

    const onCloseModal = () => {
        onClose();
        dispatch(UpdateOpenStepsList(true));
        localStorage.setItem(KEY_LOCAL_STORAGE_DONT_VISIBLE_WELCOME_MODAL, true)
    }

    const onClickNext = () => {
        onClose();
        localStorage.setItem(KEY_LOCAL_STORAGE_DONT_VISIBLE_WELCOME_MODAL, true);
        if (!isConnectedCalendar) {
            handleClickNextStep1List();
        } else if (isNextStepThree) {
            handleClickNextStep2List();
        } else {
            handleClickNextStep4List();
        }
    }

    return (
        <Modal
            classNames={{
                wrapper: 'welcome_modal__wrapper',
            }}
            open={open}
            onCancel={onCloseModal}
            centered
        >
            <div className="welcome_modal__container">
                <div className="welcome_modal__header">
                    <Text size="f22" font="medium">{t('welcome_modal_title')}</Text>
                    <CloseIcon onClick={onCloseModal}/>
                </div>
                <img src={WelcomeLogo}
                     className="welcome_modal__container--img"/>
                <Text size="f18" font="medium" as="p" className="welcome_modal__container--title">{t('welcome_modal_subtitle')}</Text>
                <div className="welcome_modal__container--desc">
                    <Text size="f16" font="liteMedium" as="p" color="#828282">
                        {t('welcome_modal_desc')}
                    </Text>
                </div>
                <div className="welcome_modal__container--buttons">
                    <Button
                        text={t('get_started')}
                        onClick={isFetchingVideos === ApiStatus.LOADING ? null : onClickNext}
                        rightIcon={isFetchingVideos === ApiStatus.LOADING ? <Loader size={30} color="white"/> : null}
                    />
                </div>
            </div>
        </Modal>
    );
};

export default WelcomeModal;